import { render, staticRenderFns } from "./PriorityFlag.vue?vue&type=template&id=3fed94d0&scoped=true&"
import script from "./PriorityFlag.vue?vue&type=script&lang=js&"
export * from "./PriorityFlag.vue?vue&type=script&lang=js&"
import style0 from "./PriorityFlag.vue?vue&type=style&index=0&id=3fed94d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed94d0",
  null
  
)

export default component.exports